import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/template/$blueprintId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      params: {
        blueprintId: params.blueprintId,
      },
      to: "/strategy/$blueprintId",
    });
  },
});
